const statusLabels = {
  active: "Actif",
  trial: "Essai",
  suspended: "Suspendu",
  inactive: "Inactif",
  canceled: "Résilié",
  cancelled: "Résilié",
  invited: "Invité",
  disabled: "Désactivé",
  trialing: "En période d’essai",
  past_due: "Paiement en retard",
};

export const formatAdminStatus = (status) => statusLabels[status] || status || "—";

const roleLabels = {
  owner: "Propriétaire",
  admin: "Administrateur",
  member: "Membre",
  viewer: "Lecteur",
};

export const formatAdminRole = (role) => roleLabels[role] || role || "—";

const runStatusLabels = {
  queued: "En attente",
  running: "En cours",
  succeeded: "Réussie",
  failed: "Échouée",
  awaiting_approval: "Validation requise",
  cancelled: "Annulée",
};

export const formatAdminRunStatus = (status) => runStatusLabels[status] || status || "—";